<div class="item-list-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <div class="grid-buttons">
    <dx-button icon="add" hint="{{ 'SHARED.ADD' | translate }}"
               (onClick)="add()"></dx-button>
    <dx-button icon="print" hint="{{ 'SHARED.PRINT' | translate }}"
               (onClick)="print()"></dx-button>
  </div>
  <br />
  <dx-data-grid #buyersGrid id="printSection"
                [allowColumnReordering]="true"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                [dataSource]="items"
                [hoverStateEnabled]="true"
                [rtlEnabled]="rtlEnabled"
                [showBorders]="true"
                [rowAlternationEnabled]="true"
                (onRowClick)="edit($event)"
                (onExporting)="onExporting($event)">
    <dxo-export [enabled]="true"></dxo-export>
    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="storage_buyers"></dxo-state-storing>
    <dxo-pager [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]"
               [showInfo]="true"
               [showNavigationButtons]="true"
               [showPageSizeSelector]="true"
               [visible]="true"
               infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}">
    </dxo-pager>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="boolean" dataField="isActive" caption="{{ 'SHARED.IS_ACTIVE' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="name" caption="{{ 'SHARED.NAME' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="email" caption="{{ 'SHARED.EMAIL' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="telNumber" caption="{{ 'SHARED.TEL_NUMBER' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="vat" caption="{{ 'SHARED.VAT' | translate }}" [visible]="false">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="address1" caption="{{ 'SHARED.ADDRESS1' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="zip" caption="{{ 'SHARED.ZIP' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="city" caption="{{ 'SHARED.CITY' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="country" caption="{{ 'SHARED.COUNTRY' | translate }}">
    </dxi-column>
    <dxi-column type="buttons" caption="..." [allowHiding]="false">
      <dxi-button icon="user" hint="{{ 'SHARED.SHOW_RELATED_USERS' | translate }}"
                  [onClick]="navigateToUsers"></dxi-button>
      <dxi-button icon="edit" hint="{{ 'SHARED.EDIT' | translate }}"
                  [onClick]="edit"></dxi-button>
      <dxi-button icon="check" hint="{{ 'BUYER.DEACTIVATE_BUYER' | translate }}"
                  [onClick]="enableDisableBuyer"
                  [visible]="calculateDisabledDisplayValue"></dxi-button>
      <dxi-button icon="remove" hint="{{ 'BUYER.ACTIVATE_BUYER' | translate }}"
                  [onClick]="enableDisableBuyer"
                  [visible]="calculateEnabledDisplayValue"></dxi-button>
      <dxi-button icon="trash" hint="{{ 'SHARED.DELETE' | translate }}"
                  [onClick]="deleteItem"></dxi-button>
    </dxi-column>
  </dx-data-grid>
</div>

<buyer-component #details
                 (onClosed)="onDetailsComponentClosed($event)"></buyer-component>
<confirmation-component #confirmation title="{{ 'BUYER.DELETE_BUYER' | translate }}"
                        message="{{ 'BUYER.DELETE_BUYER_MESSAGE' | translate }}"
                        buttonCloseText="{{ 'SHARED.DELETE' | translate }}" cancellable="true" (close)="deleteSelected();"></confirmation-component>
